import { Injectable } from '@angular/core';

@Injectable()
export class PageTitleService {

    constructor() { }

    /**
     * Set the hidden div that is read by screen readers to the page title
     * To ensure that screen readers are notified when the page title changes, we used a hidden element(sr-omly) in the DOM with aria-live attribute.
     * Using an aria-live region ensures that the changes in the div are communicated to the screen reader properly.
     * pageTitleElement is the hidden element in the DOM that is used to announce the page title changes.
     * @param pageTitle - The title of the page
     */
    public setPageTitleToSROnlyDiv(pageTitle: string) {
        const pageTitleElement = document.getElementById('pageTitle');
        if (pageTitleElement) {
            pageTitleElement.textContent = pageTitle;
        }
    }

}